var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlackDisabledIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16320_23238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.10938 15.6376C5.10938 17.0119 3.9885 18.1345 2.61394 18.1345C1.23937 18.1345 0.117188 17.0119 0.117188 15.6376C0.117188 14.2632 1.23975 13.1406 2.61412 13.1406H5.10956L5.10938 15.6376ZM6.36731 15.6376C6.36731 14.2632 7.48987 13.1406 8.86425 13.1406C10.2386 13.1406 11.3612 14.263 11.3612 15.6376V21.8879C11.3612 23.2623 10.2388 24.3848 8.86425 24.3848C7.48987 24.3848 6.36731 23.2623 6.36731 21.8879V15.6376Z",
    fill: "url(#paint0_linear_16320_23238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86425 5.60938C7.48987 5.60938 6.36731 4.4885 6.36731 3.11394C6.36731 1.73937 7.48987 0.617188 8.86425 0.617188C10.2386 0.617188 11.3612 1.73975 11.3612 3.11412V5.60956L8.86425 5.60938ZM8.86425 6.86731C10.2386 6.86731 11.3612 7.98987 11.3612 9.36425C11.3612 10.7386 10.2388 11.8612 8.86425 11.8612H2.61394C1.23956 11.8612 0.117188 10.7388 0.117188 9.36425C0.117188 7.98987 1.23975 6.86731 2.61412 6.86731H8.86425Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8924 9.36425C18.8924 7.98987 20.0133 6.86731 21.3879 6.86731C22.7624 6.86731 23.8848 7.98987 23.8848 9.36425C23.8848 10.7386 22.7623 11.8612 21.3879 11.8612H18.8924V9.36425ZM17.6345 9.36425C17.6345 10.7386 16.5119 11.8612 15.1376 11.8612C13.7632 11.8612 12.6406 10.7388 12.6406 9.36425V3.11394C12.6406 1.73956 13.763 0.617188 15.1376 0.617188C16.5119 0.617188 17.6345 1.73975 17.6345 3.11412V9.36425Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1376 19.3924C16.5119 19.3924 17.6345 20.5133 17.6345 21.8879C17.6345 23.2624 16.5119 24.3848 15.1376 24.3848C13.7632 24.3848 12.6406 23.2623 12.6406 21.8879V19.3924H15.1376ZM15.1376 18.1345C13.7632 18.1345 12.6406 17.0119 12.6406 15.6376C12.6406 14.2632 13.763 13.1406 15.1376 13.1406H21.3879C22.7623 13.1406 23.8848 14.263 23.8848 15.6376C23.8848 17.0119 22.7623 18.1345 21.3879 18.1345H15.1376Z",
    fill: "url(#paint1_linear_16320_23238)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16320_23238",
    x1: 1102.38,
    y1: 14.951,
    x2: 662.246,
    y2: 471.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A0A0A0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16320_23238",
    x1: 1114.92,
    y1: 14.951,
    x2: 674.788,
    y2: 471.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A0A0A0",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16320_23238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackDisabledIcon);
export default __webpack_public_path__ + "static/media/SlackDisabledIcon.45c03ad5f989e6f0338b7dfdd9c7496b.svg";
export { ForwardRef as ReactComponent };